<template>
    <div class="p-posters">
        <router-view />
    </div>
</template>

<script>
import {mapMutations} from 'vuex'

export default {
    name: 'PPosters',
    props: {
        posterId: {
            type: [String,Number],
            default: null
        }
    },
    methods: {
        ...mapMutations([
            'setTerminalCode',
        ]),
    },
    mounted() {
        this.setTerminalCode(this.posterId);
    }
}
</script>
